import React, { forwardRef, useId } from 'react';
import clsx from 'clsx';
import { getBoxRestrictedProperties } from '../Box';
import { aggregate, useControlledValue } from '../../utils';
import { Text } from '../Text';
import { FormField, labelId, validationTextId, helperTextId, } from '../FormField';
import './RangeSlider.css';
export const RangeSlider = forwardRef(function RangeSlider(props, ref) {
    const { value: userValue, onChange, defaultValue = 0, min = 0, max = 100, id: userId, ticks, step, className, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, inputRef, label, helperText, validationText, autoFocus, ...rest } = props;
    const uniqueId = useId();
    const id = userId !== null && userId !== void 0 ? userId : uniqueId;
    const labelledBy = aggregate(label ? labelId(id) : undefined, ariaLabelledBy);
    const describedBy = aggregate(validationText ? validationTextId(id) : undefined, helperText ? helperTextId(id) : undefined, ariaDescribedBy);
    const [value, setValue] = useControlledValue({
        value: userValue,
        onChange,
        defaultValue,
    });
    const [boxRestrictedProps, inputProps] = getBoxRestrictedProperties(rest);
    return (React.createElement(FormField, { ...boxRestrictedProps, htmlFor: id, label: label, helperText: helperText, validationText: validationText, className: className, ref: ref },
        React.createElement("div", { className: clsx('mollie-ui-range-slider', {
                'mollie-ui-range-slider--has-ticks': !!ticks,
            }, className), style: {
                '--value': value,
                '--min': min,
                '--max': max,
            } },
            React.createElement("input", { ...inputProps, id: id, type: "range", min: min, max: max, value: value, step: step, onChange: (e) => {
                    setValue(Number(e.currentTarget.value));
                }, "aria-labelledby": labelledBy || undefined, "aria-describedby": describedBy || undefined, className: "mollie-ui-range-slider-input", ref: inputRef, autoFocus: autoFocus, "data-autofocus": autoFocus }),
            React.createElement("div", { className: "mollie-ui-range-slider-track" }),
            ticks && (React.createElement("div", { className: "mollie-ui-range-slider-ticks" }, ticks.map(({ value, label, description }) => (React.createElement("div", { key: value, style: { '--value': value }, className: "mollie-ui-range-slider-tick" },
                label && (React.createElement(Text.Span, { variant: "caption-regular" }, label)),
                description && (React.createElement(Text.Span, { variant: "caption-regular" }, description))))))))));
});
//# sourceMappingURL=RangeSlider.js.map